import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewContainerRef,
} from '@angular/core';
import { CatalogRepositoryService } from '../../services/catalog-repository.service';

@Component({
  selector: 'app-mobile-filters-modal-catalog',
  templateUrl: './mobile-filters-modal-catalog.component.html',
  styleUrls: ['./mobile-filters-modal-catalog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileFiltersModalCatalogComponent {
  constructor(public repository: CatalogRepositoryService) {}

  @Input() container: ViewContainerRef | undefined;

  closeModal(): void {
    this.container?.clear();
  }
}
